module.exports = __webpack_public_path__ + "static/spy-cutout-f6ab8099767ded36b8a8ce068ecfedb7.png";